export enum LlmToolCategoryType {
  Read = 'read',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}
